import { isArray } from "lodash";

const getItemTitleFromTitle = (title: string) => {
	if (!title) {
		return "Item";
	}
	const parts = title.split(" ");
	const lastPart = parts.at(-1);

	if (!lastPart) {
		return "Item";
	}

	const sanitizedTitle = lastPart.replace(/[^a-zA-Z\s]/g, "");

	if (sanitizedTitle.endsWith("s")) {
		return sanitizedTitle.slice(0, -1);
	}
	return lastPart;
};

const getPropertiesList = (item: object) => {
	return Object.entries(item).map(([key, value]) => ({
		displayName: camelCaseToTitle(key),
		dataType: isArray(value) ? "list" : typeof value,
		value,
	}));
};

const camelCaseToWords = (str: string) => {
	return str
		.replace(/([a-z0-9])([A-Z])/g, "$1 $2")
		.replace(/([A-Z])([A-Z][a-z])/g, "$1 $2")
		.split(" ");
};

const camelCaseToTitle = (str: string) => {
	return camelCaseToWords(str)
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(" ");
};

export { getItemTitleFromTitle, getPropertiesList, camelCaseToTitle, camelCaseToWords };
